import styled from 'styled-components';

const ProfileContainer = styled.div`
  .profile-content {
    display: flex;
    background: #fff;
    border-radius: 10px;
    flex-direction: column;
    background: ${({ theme }) => theme.Bg1};
    .img-container {
      height: 150px;
      overflow: hidden;
      border-radius: 10px;
      position: relative;
      border: 1px solid ${({ theme }) => theme.border1};
      background-color: ${({ theme }) => theme.lightGray};
      .sub-profile {
        width: 100%;
        height: inherit;
        object-fit: cover;
      }
      .edit-icons {
        position: absolute;
        top: 5px;
        right: 5px;
        background-color: ${({ theme }) => theme.lightGray};
        border-radius: 50%;
        &:hover {
          background-color: ${({ theme }) => theme.lightGrayHover};
        }
        path {
          fill: ${({ theme }) => theme.fieldText1};
        }
      }
    }
  }
`;

const ProfileWaterMark = styled.div`
  width: 100%;
  height: 150px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  position: relative;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .watermark-text {
    position: absolute;
    font-size: 14px;
    color: ${({ theme }) => theme.mode === 'light' ? '#00000014' : '#6b6b6b61'};
    pointer-events: none;
    transform: rotate(-30deg);
  }
  .watermark-text:nth-child(1) {
    top: 25px;
    left: 3%;
  }
  .watermark-text:nth-child(2) {
    top: 100px;
    left: 3%;
  }
  .watermark-text:nth-child(3) {
    top: 25px;
    left: 29%;
  }
  .watermark-text:nth-child(4) {
    top: 100px;
    left: 29%;
  }
  .watermark-text:nth-child(5) {
    top: 25px;
    left: 55%;
  }
  .watermark-text:nth-child(6) {
    top: 100px;
    left: 55%;
  }
  .watermark-text:nth-child(7) {
    top: 25px;
    left: 80%;
  }
  .watermark-text:nth-child(8) {
    top: 100px;
    left: 80%;
  }
`

const ProfileMenuListContainer = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.text1};
  .profile-item {
    display: flex;
    padding: 10px 12px;
    align-items: center;
    justify-content: space-between;
    /* width: 140px; */
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    svg {
      width: 24px;
      height: 24px;
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .other-profile-item {
    display: flex;
    padding: 10px 12px;
    align-items: center;
    min-width: 150px;
    cursor: pointer;
    border-radius: 2px;
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    >div {
      max-width: 200px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &:not(.profile-mute) {
      svg {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        fill: ${({ theme }) => theme.svg1};
        path {
          fill: ${({ theme }) => theme.svg1} !important;
        }
      }
    }
  }
  .common-profile-item {
    display: flex;
    padding: 10px 12px;
    align-items: center;
    min-width: 150px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    svg {
      width: 18px;
      height: 18px;
      margin-right: 12px;
      fill: ${({ theme }) => theme.svg1};
      path {
        fill: ${({ theme }) => theme.svg1} !important;
      }
    }
  }
  .common-profile-item-report {
    color: ${({ theme }) => theme.red1} !important;
    svg {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      position: relative;
      left: -2px;
      path {
        fill: ${({ theme }) => theme.red1} !important;
      }
    }
  }
  .profile-mute {
    svg {
      width: 22px;
      height: 22px;
      margin-right: 10px;
      color: ${({ theme }) => theme.svg1};
    }
  }
  .share-profile-item {
    svg {
      width: 18px;
      height: 18px;
      margin-right: 10px;
      path {
        fill: ${({ theme }) => theme.svg1} !important;
      }
    }
  }
  .deletelist-icon {
    svg {
      fill: ${({ theme }) => theme.red1} !important;
    }
    color: ${({ theme }) => theme.red1} !important;
  }
`

export { ProfileContainer, ProfileWaterMark, ProfileMenuListContainer };
